__turbopack_context__.v({
  "paginationDashAnimated": "index-module__SNEUEq__paginationDashAnimated",
});
